import { useLegacyDialogProps } from 'components/DialogV3/DialogManagerContext';
import { LoadingButton } from '@mui/lab';
import { Box, Button, DialogActions, DialogContent, DialogContentText, IconButton, InputAdornment, Typography } from '@mui/material';
import apiManagerRole from 'api/manager-role';
import { IconClose } from 'assets/icons';
import TextFieldVMP from 'components/common/TextField/TextFieldVMP';
import { NS_TRANS } from 'constants/common';
import { TOAST_DEFAULT } from 'constants/toast';
import { API_CODE_CREATE_ROLE } from 'pages/manager-roles/constant';
import { handleValidateRole } from 'pages/manager-roles/hooks/useHandleValidateRole';
import { setIsSubmit, setSearchQuery } from 'pages/manager-roles/store/managerRoleSlice';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import SwitchIOS from 'shared/components/base/SwitchIOS';
import toastService from 'shared/ui/toast';
import { color } from 'theme';
import { setCloseDialogCC, toastError, toastSuccess } from 'utils/helpers';
import DialogBaseCC from './DialogBaseCC';
import { DIALOG_ID } from './constant';

const DialogCreateOrUpdateRole = () => {
    const propsDialog = useLegacyDialogProps();
    const { title, titleButtonAction, titleButtonCancel, data } = propsDialog
    const { open } = useSelector((state) => state.dialog);
    const { searchQuery } = useSelector(state => state.managerrole);
    const dispatch = useDispatch();
    const { t } = useTranslation([NS_TRANS.MANAGE_ROLE]);
    const [newItem, setNewItem] = useState({
        name: "",
        description: "",
        is_active: 1,
        priority: 1,
    });
    const [errorValid, setErrorValid] = useState(() => handleValidateRole(newItem, t));
    const [clickSubmit, setClickSubmit] = useState(false);
    const [isUpdating, setIsUpdating] = useState(false);

    const apiAddRole = (data) => {
        return apiManagerRole.addRole(data)
    }

    const apiEditRole = (id, data) => {
        return apiManagerRole.editRole(id, data);
    }

    const handleAddRole = (data) => {
        const convertData = {
            name: data.name.trim(),
            is_active: data.is_active,
            priority: data.priority,
            description: data.description.trim()
        }
        apiAddRole(convertData)
            .then(res => {
                toastService.apiToast({ res, code: API_CODE_CREATE_ROLE })
                setCloseDialogCC()
                setNewItem({
                    name: "",
                    description: "",
                    is_active: 1,
                    priority: 1,
                    functions: []
                })
                dispatch(setIsSubmit(true));
                setTimeout(() => {
                    dispatch(setIsSubmit(false));
                    dispatch(setSearchQuery({
                        ...searchQuery,
                        page: 0
                    }))
                }, 100)
            })
            .catch(error => {
                if (error?.response?.data?.detail === "Name has been used") {
                    toastError(t('toast.used-role'))
                } else {
                    toastError(t(TOAST_DEFAULT.ERROR))
                }

            })
            .finally(() => {
                setIsUpdating(false)
            })
    }

    const handleEditRole = (id, data) => {
        const convertData = {
            name: data.name.trim(),
            is_active: data.is_active.toString(),
            priority: data.priority,
            description: data.description.trim()
        }
        apiEditRole(id, convertData)
            .then(res => {
                dispatch(setIsSubmit(true));
                toastSuccess(t('pgRole:toast.update-success-role'))
                dispatch(setIsSubmit(false));
            })
            .catch(error => {
                if (error?.response?.data?.detail === "Name has been used") {
                    toastError(t('toast.name-role-used'))
                } else if (error?.response?.data?.detail === "Role is not existed") {
                    toastError(t('toast.role-not-existed'))
                } else toastError(t("toast.Error"))
            })
            .finally(() => {
                setCloseDialogCC();
                setIsUpdating(false);
            })
    }

    const handleCloseDialog = () => {
        setCloseDialogCC();
        setNewItem({
            name: "",
            description: "",
            is_active: 1,
            priority: 1,
        })
    }

    const handleAction = () => {
        setClickSubmit(true);
        setIsUpdating(true)
        if (errorValid['name']?.value) {
            setIsUpdating(false);
        } else if (errorValid['description']?.value) {
            setIsUpdating(false);
        } else if (errorValid['priority']?.value) {
            setIsUpdating(false);
        } else if (title === t('manageRole:dialog.titleUpdateRole')) {
            handleEditRole(data?.id, newItem)
        } else {
            handleAddRole(newItem)
        }
    }

    useEffect(() => {
        setErrorValid((prev) => handleValidateRole(newItem, t));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [newItem]);

    useEffect(() => {
        if (data) {
            setNewItem({
                name: data?.name,
                description: data?.description,
                is_active: data?.is_active,
                priority: data?.priority
            })
        }
    }, [data])

    useEffect(() => {
        if (!open) {
            setNewItem({
                name: "",
                description: "",
                is_active: 1,
                priority: 1,
                functions: []
            })
            setErrorValid({
                name: { value: false, helperText: '' },
                description: { value: false, helperText: '' },
                is_active: { value: false, helperText: '' },
                priority: { value: false, helperText: '' },
            })
            setClickSubmit(false)
        }
    }, [open])

    return (
        <DialogBaseCC id={DIALOG_ID.CREATE_OR_UPDATE_ROLE} title={title}>
            <DialogContent sx={{ minWidth: '500px !important' }}>
                <DialogContentText>
                    <Box>
                        <Box sx={{ marginTop: { xs: '0.5rem', xl: '1rem' } }}>
                            <Typography>{t('dialog.titleRole')}<span style={{ color: color.main }}>*</span></Typography>
                            <TextFieldVMP
                                autoFocus
                                error={clickSubmit && errorValid['name']?.value}
                                helperText={clickSubmit && t(errorValid['name']?.helperText)}
                                value={newItem.name}
                                onChange={e => {
                                    setNewItem({
                                        ...newItem,
                                        name: e.target.value
                                    })
                                }}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            {newItem.name !== '' ? (
                                                <IconButton
                                                    tabIndex={-1}
                                                    aria-label="toggle password visibility"
                                                    onClick={() => {
                                                        setNewItem({
                                                            ...newItem,
                                                            name: ""
                                                        })
                                                    }}
                                                    sx={{ p: 0.5 }}
                                                >
                                                    <IconClose />
                                                </IconButton>
                                            ) : (
                                                <></>
                                            )}
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Box>
                        <Box sx={{ marginTop: { xs: '0.5rem', xl: '1rem' } }}>
                            <Typography>{t('dialog.description')}</Typography>
                            <TextFieldVMP
                                error={clickSubmit && errorValid['description']?.value}
                                helperText={clickSubmit && t(errorValid['description']?.helperText)}
                                value={newItem.description}
                                onChange={e => {
                                    setNewItem({
                                        ...newItem,
                                        description: e.target.value
                                    })
                                }}
                                multiline
                                rows={4}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            {newItem.description !== '' ? (
                                                <IconButton
                                                    tabIndex={-1}
                                                    aria-label="toggle password visibility"
                                                    onClick={() => {
                                                        setNewItem({
                                                            ...newItem,
                                                            description: ""
                                                        })
                                                    }}
                                                    sx={{ p: 0.5 }}
                                                >
                                                    <IconClose />
                                                </IconButton>
                                            ) : (
                                                <></>
                                            )}
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Box>
                        <Box sx={{ marginTop: { xs: '0.5rem', xl: '1rem' } }}>
                            <Typography>{t('dialog.priority')}<span style={{ color: color.main }}>*</span></Typography>
                            <TextFieldVMP
                                error={clickSubmit && errorValid['priority']?.value}
                                helperText={clickSubmit && t(errorValid['priority']?.helperText)}
                                type="number"
                                value={newItem.priority}
                                onChange={e => {
                                    setNewItem({
                                        ...newItem,
                                        priority: e.target.value
                                    })
                                }}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            {newItem.priority !== '' ? (
                                                <IconButton
                                                    tabIndex={-1}
                                                    aria-label="toggle password visibility"
                                                    onClick={() => {
                                                        setNewItem({
                                                            ...newItem,
                                                            priority: ""
                                                        })
                                                    }}
                                                    sx={{ p: 0.5 }}
                                                >
                                                    <IconClose />
                                                </IconButton>
                                            ) : (
                                                <></>
                                            )}
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Box>
                        <Box sx={{ marginTop: { xs: '0.5rem', xl: '1rem' } }}>
                            <Typography sx={{ color: theme => theme.palette.text.primary }}>{t('dialog.status')}</Typography>
                            <SwitchIOS
                                checked={parseInt(newItem.is_active) === 1 ? true : false}
                                onChange={(e) => {
                                    setNewItem({
                                        ...newItem,
                                        is_active: newItem.is_active === 1 ? 0 : 1
                                    })
                                }}
                            />
                        </Box>
                    </Box>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button variant='outlined' onClick={() => { handleCloseDialog() }}>{titleButtonCancel}</Button>
                <LoadingButton variant='contained' loading={isUpdating} onClick={() => { handleAction() }}>{titleButtonAction}</LoadingButton>
            </DialogActions>
        </DialogBaseCC>
    )
}

export default DialogCreateOrUpdateRole;